// Ce Fichier Gére toutes les requetes que l'utilisateur peut faire sur l'application aprés l authentification .

import { apiSlice } from "./apiSlice";

// Injecte les endpoints spécifiques pour la gestion des utilisateurs et des onglets dans apiSlice
export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Endpoint pour récupérer tous les utilisateurs
    getAllUsers: builder.query<any, void>({
      query: () => "users", // URL relative de l'endpoint
      providesTags: (result) => {
        console.log("getAllUsers result:", result);
        return result
          ? [
              ...result.map(({ id }: any) => ({ type: "User", id })),
              { type: "User", id: "LIST" },
            ]
          : [{ type: "User", id: "LIST" }];
      },
    }),

    // Endpoint pour récupérer un utilisateur par son ID
    getUserById: builder.query<any, any>({
      query: (id) => `users/${id}`, // URL relative de l'endpoint
      providesTags: (result, error, id) => {
        console.log("getUserById result:", result);
        console.log("getUserById error:", error);
        return [{ type: "User", id }];
      },
    }),

    // Endpoint pour mettre à jour un utilisateur
    updateUser: builder.mutation<any, any>({
      query: ({ id, updatedInfos }) => ({
        url: `users/${id}`, // URL relative de l'endpoint
        method: "PUT", // Méthode HTTP
        body: updatedInfos, // Corps de la requête avec les informations mises à jour
      }),
      invalidatesTags: (result, error, { id }) => {
        console.log("updateUser result:", result);
        console.log("updateUser error:", error);
        return [
          { type: "User", id },
          { type: "User", id: "LIST" },
        ];
      },
    }),

    // Endpoint pour créer un nouvel utilisateur
    createUser: builder.mutation<any, any>({
      query: (user) => ({
        url: `users`, // URL relative de l'endpoint
        method: "POST", // Méthode HTTP
        body: user, // Corps de la requête avec les informations de l'utilisateur à créer
      }),
      invalidatesTags: [{ type: "User", id: "LIST" }], // Invalide le tag "LIST" des utilisateurs après création
    }),

    // Endpoint pour supprimer un utilisateur
    deleteUser: builder.mutation<any, any>({
      query: (id) => ({
        url: `users/${id}`, // URL relative de l'endpoint
        method: "DELETE", // Méthode HTTP
      }),
      invalidatesTags: (result, error, id) => {
        console.log("deleteUser result:", result);
        console.log("deleteUser error:", error);
        return [
          { type: "User", id },
          { type: "User", id: "LIST" },
        ];
      },
    }),

    // Endpoint pour récupérer tous les onglets
    getTabs: builder.query<any, void>({
      query: () => `tabs`, // URL relative de l'endpoint
      providesTags: [{ type: "Tab", id: "LIST" }], // Fournit le tag "LIST" des onglets
    }),

    // Endpoint pour récupérer un onglet par son ID
    getTabById: builder.query<any, any>({
      query: (id) => `tabs/${id}`, // URL relative de l'endpoint
      providesTags: (result, error, id) => {
        console.log("getTabById result:", result);
        console.log("getTabById error:", error);
        return [{ type: "Tab", id }];
      },
    }),

    // Endpoint pour mettre à jour un onglet
    updateTab: builder.mutation<any, any>({
      query: ({ id, updatedInfos }) => ({
        url: `tabs/${id}`, // URL relative de l'endpoint
        method: "PUT", // Méthode HTTP
        body: updatedInfos, // Corps de la requête avec les informations mises à jour de l'onglet
      }),
      invalidatesTags: (result, error, { id }) => {
        console.log("updateTab result:", result);
        console.log("updateTab error:", error);
        return [
          { type: "Tab", id },
          { type: "Tab", id: "LIST" },
        ];
      },
    }),

    // Endpoint pour supprimer un onglet
    deleteTab: builder.mutation<any, any>({
      query: (id) => ({
        url: `tabs/${id}`, // URL relative de l'endpoint
        method: "DELETE", // Méthode HTTP
      }),
      invalidatesTags: (result, error, id) => {
        console.log("deleteTab result:", result);
        console.log("deleteTab error:", error);
        return [
          { type: "Tab", id },
          { type: "Tab", id: "LIST" },
        ];
      },
    }),

    // Endpoint pour créer un nouvel onglet
    createTab: builder.mutation<any, any>({
      query: (tab) => ({
        url: `tabs`, // URL relative de l'endpoint
        method: "POST", // Méthode HTTP
        body: tab, // Corps de la requête avec les informations de l'onglet à créer
      }),
      invalidatesTags: [{ type: "Tab", id: "LIST" }], // Invalide le tag "LIST" des onglets après création
    }),

    // Endpoint pour récupérer les onglets d'un utilisateur spécifique
    getUserTabs: builder.query<any, any>({
      query: (id) => ({
        url: `users/${id}/tabs/view`, // URL relative de l'endpoint
        method: "GET", // Méthode HTTP
      }),
      providesTags: (result, error, id) => {
        console.log("getUserTabs result:", result);
        console.log("getUserTabs error:", error);
        return [{ type: "User", id: `TABS_${id}` }]; // Fournit un tag unique pour les onglets de l'utilisateur
      },
    }),

    // Endpoint pour éditer les onglets d'un utilisateur
    editUserTabs: builder.mutation<any, any>({
      query: ({ id, tabs }) => ({
        url: `users/${id}/tabs/edit`, // URL relative de l'endpoint
        method: "PUT", // Méthode HTTP
        body: tabs, // Corps de la requête avec les onglets mis à jour de l'utilisateur
      }),
      invalidatesTags: (result, error, { id }) => {
        console.log("editUserTabs result:", result);
        console.log("editUserTabs error:", error);
        return [
          { type: "User", id: `TABS_${id}` }, // Invalide les tags des onglets de l'utilisateur spécifique
          { type: "User", id: "LIST" }, // Invalide le tag "LIST" des utilisateurs après édition des onglets
        ];
      },
    }),
  }),
});

// Exporte les hooks générés automatiquement pour chaque endpoint de usersApiSlice
export const {
  useGetAllUsersQuery,
  useGetUserByIdQuery,
  useUpdateUserMutation,
  useCreateUserMutation,
  useDeleteUserMutation,
  useGetTabsQuery,
  useGetTabByIdQuery,
  useUpdateTabMutation,
  useDeleteTabMutation,
  useCreateTabMutation,
  useGetUserTabsQuery,
  useEditUserTabsMutation,
} = usersApiSlice;
